import { h, Component, Fragment } from "preact";
import { Form, I18n } from "components/elements";
import { connect } from "react-redux";
import style from "./style.less";
import LoadingIcon from "components/elements/LoadingIcon";
import LottieAnimation from "components/elements/LottieAnimation";
import animationSuccess from "../../../assets/animations/success.json"

@Form
@connect((state) => ({
	...state,
}))
export default class WaitingRoom extends Component {
	constructor() {
		super();
	}

	get waitingRoom() {
		return this.props.waitingRoom || [];
	}

	get appointments() {
		return this.props.appointments || {};
	}

	get appointmentLength() {
		let appointmentType = Object.values(this.props.appointmentTypes || {})[0];
		if (appointmentType) {
			return (appointmentType.durations || "").split(",")[0];
		}
		return 0;
	}

	get administrators() {
		let administrators = Object.values(this.props.administrators);
		return administrators.filter((admin) => {
			return !admin.isWaitingRoom;
		});
	}

	get queue() {
		return _.flatten(this.waitingRoom);
	}

	get isInQueue() {
		let appointmentIDs = Object.keys(this.appointments);
		if (_.intersection(appointmentIDs, this.queue).length > 0) {
			return true;
		}
		return false;
	}

	get positionInQueue() {
		for (let appointmentID of Object.keys(this.appointments)) {
			if (this.queue.includes(appointmentID)) {
				return this.queue.indexOf(appointmentID) + 1;
			}
		}
		return -1;
	}

	get inQueueWaitTime() {
		if (this.waitingRoom.length > 1) {
			let columnCount = this.waitingRoom[0].length;
			const row = parseInt(this.positionInQueue / columnCount) + 1;
			return row * this.appointmentLength;
		} else {
			return this.appointmentLength;
		}
	}
	get notInQueueWaitTime() {
		if (this.waitingRoom.length > 1) {
			let rowCount = this.waitingRoom.length;
			if (this.administrators.length == this.waitingRoom[0].length) {
				rowCount = rowCount + 1;
			}
			return rowCount * this.appointmentLength;
		} else {
			return this.appointmentLength;
		}
	}

	hourlyWaitTime(value) {
		return {
			hours: parseInt(value / 60),
			minutes: value - parseInt(value / 60) * 60,
		};
	}

	render() {		
		const queueComponent = () => {
			const { isInQueue, positionInQueue } = this;
			// const positionInQueue = 2;
			const flag = !isInQueue || (isInQueue && positionInQueue > 1);

			return flag ? (
				<div className={style.queue}>
					<div className={style.queueText}>
						{isInQueue ? (
							<I18n>youAreCurrentlyNumber</I18n>
						) : (
							<I18n>InLine</I18n>
						)}
					</div>
					<div className={style.positionQueue}>
						<span>{isInQueue ? positionInQueue : this.queue.length}</span>
						<span>
							{isInQueue ? (
								<I18n>inLine</I18n>
							) : (
								<I18n>{this.queue.length == 1 ? "person" : "people"}</I18n>
							)}
						</span>
					</div>
					<div className={style.queueText}>
						{isInQueue ? (
							<I18n>yourEstimatedWaitTimeIs</I18n>
						) : (
							<I18n>theEstimatedWaitTimeIs</I18n>
						)}
						&nbsp;
						{this.inQueueWaitTime > 59 ? (
							<Fragment>
								<span>{this.hourlyWaitTime(this.inQueueWaitTime).hours}</span>
								&nbsp;
								<I18n>and</I18n>&nbsp;
								<span>{this.hourlyWaitTime(this.inQueueWaitTime).minutes}</span>
								&nbsp;
								<I18n>minutes</I18n>.
							</Fragment>
						) : (
							<Fragment>
								<span>{this.inQueueWaitTime}</span>&nbsp;
								<I18n>minutes</I18n>.
							</Fragment>
						)}
					</div>
				</div>
			) : (
                <div className={style.noticeMessage}>
                    <div className={style.animation}>
                        <LottieAnimation animationData={animationSuccess} loop={false} />
                    </div>
                    <div className={style.message}>
                        <span className={style.headerMessage}>
                            <I18n>youAreNextInLine</I18n>
                        </span>
                        <span className={style.contentMessage}>
                            <I18n>vetIsReadyMessage</I18n>
                        </span>
                    </div>
                </div>
			);
		};
				
		return (
			<div class={style.waitingRoom}>
				{!this.props.closed && (
					<Fragment>
						{this.props.spinner ? (
							<div class={style.spinnerContainer}>
								<LoadingIcon size={100} />
							</div>
						) : this.queue.length === 0 && !this.isInQueue ? (
							<div className={style.messageWithoutQueue}>
                                <div className={style.animation}>
                                    <LottieAnimation animationData={animationSuccess} loop={false} />
                                </div>
                                <div className={style.message}>
                                    <span className={style.headerMessage}>
                                        <I18n>thereIsNoOneAheadOfYou</I18n>
                                    </span>
                                    <span className={style.contentMessage}>
                                        <I18n>goAHeadMessageContent</I18n>
                                    </span>
                                </div>
							</div>
						) :  this.queue.length > 0  && (
							queueComponent()
						)}
					</Fragment>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/WaitingRoom/index.js